import { GrupoPermissao } from './../../grupo-permissao/models/grupo-permissao';
import { Entidade } from './../../entidade/models/entidade';


    export class Usuario
    {
        constructor() {
          this.Id = 0;
          this.Cpf = "";
          this.Nome = "";
          this.SobreNome = "";
          this.Senha = "";
          this.Ativo = false;
          this.Bloqueado = false;
          this.Excluido = false;
          this.DataCriacao = "1990-01-02T00:00:01";
          this.DataBloqueado = "1990-01-02T00:00:01";
          this.DataExclusao = "1990-01-02T00:00:01";
          this.UsuarioCriacao = "";
          this.UsuarioComplemento = new UsuarioComplemento();
          this.Token = new Token();
          this.GrupoPermissao = new GrupoPermissao();
          this.ConfirmaSenha = "";
          this.NovaSenha = "";
          this.DataTempoAcesso = "1990-01-02T00:00:01";

        }

        public Id: number     ;
        public Cpf: string      ;
        public Nome:   string   ;
        public SobreNome:string      ;
        public Senha:string;
        public Ativo:boolean      ;
        public Bloqueado: boolean     ;
        public Excluido: boolean     ;
        public DataCriacao: string      ;
        public DataBloqueado:string      ;
        public DataExclusao: string     ;
        public UsuarioCriacao:string      ;
        public UsuarioComplemento: UsuarioComplemento;

        public ConfirmaSenha: string;
        public NovaSenha: string;
        public Token: Token;
        public GrupoPermissao: GrupoPermissao;

        public DataTempoAcesso: string;
    }

    export class UsuarioComplemento
    {
        constructor()
        {
            this.IdUsuarioApiUnico = 0;
            this.Entidade = new Entidade();
            this.Perfil = new Perfil();
            this.Cargo = "";
            this.Email = "";
            this.TelefoneFixo = "";
            this.TelefoneCelular = "";
            this.Imagem = "";
        }

        public IdUsuarioApiUnico:number;
        public Entidade:Entidade      ;
        public Perfil: Perfil;
        public Cargo:string;
        public Email:string;
        public TelefoneFixo:string      ;
        public TelefoneCelular:string      ;
        public Imagem:string      ;
    }

    export class Perfil {
      constructor() {
        this.Id = 0;
        this.Descricao = '';
        this.Hierarquia = 0;}
      public Id: number;
      public Descricao: string;
      public Hierarquia: number;
    }

    export class Token {
      constructor() {
        this.Id = 0;
        this.IdUsuario = 0;
        this.Cpf = "";
        this.Email = "";
        this.TokenGerado = "";
        this.Ip = "";
        this.DataCriacao = "1990-01-02T00:00:01";
        this.DataExpiracao = "1990-01-02T00:00:01";
      }
      Id = 0;
      IdUsuario = 0;
      Cpf : string;
      Email: string;
      TokenGerado : string;
      Ip : string;
      DataCriacao : string;
      DataExpiracao : string;
    }

    export enum EnumPerfil{
      AdministradorCECAM = 1,
      AdministradorPadrao = 2,
      Coordenador = 3,
      UsuarioPadrao = 4,
    }
